import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c045ad80"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "amount-input__wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "amount-input__fiat"
}
const _hoisted_4 = {
  key: 0,
  class: "amount-input__inner-error"
}
const _hoisted_5 = {
  key: 1,
  class: "amount-input__fiat"
}

import { PropType, computed, ref, ComponentPublicInstance } from "vue";
import { Token } from "@/types/token";
import BaseButton from "@/components/base-button/index.vue";
import { nativeToken } from "@/stores";
import BigNumber from "bignumber.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  token: {
    type: Object as PropType<Token>,
    default: nativeToken,
  },
  hasEnoughBalance: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    default: "",
  },
  maxValue: {
    type: Object as PropType<BigNumber>,
    default: new BigNumber(0),
  },
  innerErrorMessage: {
    type: String,
    default: "",
  },
},
  emits: ["update:amount"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const inputRef = ref<ComponentPublicInstance<HTMLInputElement>>();
__expose({ inputRef });





const setMaxValue = () => {
  emit("update:amount", props.maxValue?.toString() || "0");
};

const amountValue = computed({
  get: () => (props.value != "0" ? props.value.replace(/[^0-9.-]+/g, "") : ""),
  set: (value) => emit("update:amount", value.replace(/[^0-9.-]+/g, "")),
});
const size = computed(() => {
  return amountValue.value.length == 0 ? 70 : amountValue.value.length;
});

const amountInFiat = computed(() => {
  return new BigNumber(props.value || 0).times(props.token.price);
});

const focus = () => {
  if (inputRef.value) inputRef.value.focus();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["amount-input", { error: __props.isError }])
  }, [
    _createElementVNode("img", {
      src: __props.token.image,
      class: "amount-input__icon"
    }, null, 8, _hoisted_1),
    _createVNode(BaseButton, {
      stroke: true,
      class: _normalizeClass(["amount-input__max", { error: !__props.hasEnoughBalance }]),
      title: "Max",
      small: true,
      onClick: setMaxValue
    }, null, 8, ["class"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "inputRef",
        ref: inputRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((amountValue).value = $event)),
        type: "text",
        class: _normalizeClass(["amount-input__input", { error: !__props.hasEnoughBalance }]),
        placeholder: "0",
        style: _normalizeStyle({ width: size.value + 'ch' })
      }, null, 6), [
        [_vModelText, amountValue.value]
      ]),
      _withDirectives(_createElementVNode("span", { onClick: focus }, _toDisplayString(__props.token.symbol), 513), [
        [_vShow, props.value != '0']
      ])
    ]),
    (props.value !== '0')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(" ~" + _toDisplayString(_ctx.$filters.currencyFormat(amountInFiat.value, "USD")) + " ", 1),
          (__props.innerErrorMessage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.innerErrorMessage), 1))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$filters.currencyFormat(0, "USD")), 1))
  ], 2))
}
}

})